var newsletterLabel = $("label[for='embedded-newsletter']");

$(document).ready(function () {

    $("#quickNewsletterForm").on("submit", function () {
        $(".quick-newsletter-subscribe-button").attr("disabled", true);
    });

    $("#newsletter-form").on("submit", function () {
        $(".subscribe-newsletter-button button[type=submit]").attr("disabled", true);
    });

    $(document).on("submit", "#newsletterBarForm", function (e) {
        var $this = $(this),
            data = $this.serialize();
        $.ajax({
            type: "POST",
            url: $this[0].action,
            data: data
        }).done(function (data) {
            $('.newsletter-bar').replaceWith(data);
        });

        e.preventDefault();
    });

    $("#embedded-newsletter").on('change', function () {
        if ($(this).prop("disabled")) return;
        newsletterLabel.toggleClass('active');
        subscribeOnNewsletter($(this).prop('checked'))
    });
});

var subscribeOnNewsletter = function (value) {
    mask();
    var action = value ? "subscribe" : "unsubscribe";
    $.ajax({
        type: 'GET',
        url: '/newsletter/embedded/' + action
    }).done(function () {
        unmask(action, 'ok');
    }).fail(function () {
        $("#embedded-newsletter").prop('checked', !value);
        if (value) {
            newsletterLabel.removeClass('active');
        } else {
            newsletterLabel.addClass('active');
        }
        unmask(action, 'ko');
    });
};

var mask = function () {
    $("#embedded-newsletter").prop("disabled", true);
    newsletterLabel.addClass('disabled');
    $('#newsletter-subscribe-ok').hide();
    $('#newsletter-unsubscribe-ok').hide();
    $('#newsletter-subscribe-ko').hide();
    $('#newsletter-unsubscribe-ko').hide();
};

var unmask = function (action, status) {
    $("#embedded-newsletter").prop("disabled", false);
    newsletterLabel.removeClass('disabled');
    if (action && status) {
        $('#newsletter-' + action + '-' + status).show();
    }
};
